import { render, staticRenderFns } from "./PaginaAgenti.vue?vue&type=template&id=aac2b6fa&"
import script from "./PaginaAgenti.vue?vue&type=script&lang=js&"
export * from "./PaginaAgenti.vue?vue&type=script&lang=js&"
import style0 from "./PaginaAgenti.vue?vue&type=style&index=0&id=aac2b6fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports